function swatchMoreCardInit() {
	document.querySelectorAll(".Card_product_main_new").forEach((element) => {
		const fabric_page_small_size_card = element.getAttribute(
			"fabric_page_small_size_card"
		);
		const cardSwatches = element.querySelectorAll("card-swatch");
		const moreCardButton = element.querySelector(".card-swatch__more-products");

		var maxVisible = window.innerWidth <= 767 ? 3 : 6;

		if (fabric_page_small_size_card == "yes") {
			var maxVisible = 4;
		}

		const totalSwatches = cardSwatches.length;
		if (totalSwatches > maxVisible) {
			cardSwatches.forEach((swatch, index) => {
				if (index >= maxVisible) {
					swatch.style.display = "none";
				}
			});
			moreCardButton.textContent = `+${totalSwatches - maxVisible}`;
		} else {
			if (moreCardButton) {
				moreCardButton.style.display = "none";
			}
		}
	});
}
swatchMoreCardInit();
document.addEventListener("swatch-more-card:init", swatchMoreCardInit);
